/* eslint-disable */

export interface YarnFormData {
  name: string
  brand: string
  length: string
  weight: string
  material: string
  length_unit: string
  weight_unit: string
  gauge_sts?: string
  gauge_rows?: string
  gauge_knitting_needle_id?: number
  gauge_needle_mm?: number
  gauge_needle_us?: number
}

export function parseYarnProfile(profile: string[], brand: string, yarnName: string): YarnFormData {
  // Parse profile data to extract yarn information
  const profileText = profile.join('\n')
  
  // Look for pattern like "100 g; 142 m (155 yds)" or "100g; 142m"
  // This pattern appears in the "Balls:" section
  const ballPattern = /(\d+(?:\.\d+)?)\s*g[;\s]+(\d+(?:\.\d+)?)\s*(m|yd|meter|yard)/i
  const ballMatch = profileText.match(ballPattern)
  
  let length = ''
  let lengthUnit = 'm'
  let weight = ''
  let weightUnit = 'g'
  
  if (ballMatch) {
    // Found the ball pattern: weight is first, length is second
    weight = ballMatch[1]
    length = ballMatch[2]
    const lengthUnitMatch = ballMatch[3] && ballMatch[3].toLowerCase()
    if (lengthUnitMatch && (lengthUnitMatch.includes('yd') || lengthUnitMatch.includes('yard'))) {
      lengthUnit = 'yd'
    }
  } else {
    // Fallback: try to find length and weight separately
    const lengthMatch = profileText.match(/(\d+(?:\.\d+)?)\s*(m|yd|meter|yard)/i)
    const weightMatch = profileText.match(/(\d+(?:\.\d+)?)\s*(g|oz|gram|ounce)/i)
    
    if (lengthMatch) {
      length = lengthMatch[1]
      const unit = lengthMatch[2] && lengthMatch[2].toLowerCase()
      if (unit && (unit.includes('yd') || unit.includes('yard'))) {
        lengthUnit = 'yd'
      }
    }
    
    if (weightMatch) {
      weight = weightMatch[1]
      const unit = weightMatch[2] && weightMatch[2].toLowerCase()
      if (unit && (unit.includes('oz') || unit.includes('ounce'))) {
        weightUnit = 'oz'
      }
    }
  }
  
  // Extract material - look for Fiber: label first, then Material: label, then percentage patterns
  // Handle formats like "Fiber:\n\nCotton (100%)" or "Fiber: Cotton (100%)"
  const fiberMatch = profileText.match(/Fiber[:\s]+\n*\s*([^\n]+)/i)
  const materialMatch = fiberMatch || 
                       profileText.match(/Material[:\s]+(.+?)(?:\n|$)/i) || 
                       profileText.match(/(\d+%\s*[^,\n]+(?:,\s*\d+%\s*[^,\n]+)*)/i)
  
  // Extract gauge information
  // Pattern: "18 sts / 10 cm (4") and 24 rows"
  const gaugeMatch = profileText.match(/(\d+)\s*sts\s*\/\s*\d+\s*cm[^a-z]*and\s*(\d+)\s*rows/i) ||
                     profileText.match(/(\d+)\s*sts[^a-z]*(\d+)\s*rows/i)
  
  let gaugeSts = ''
  let gaugeRows = ''
  
  if (gaugeMatch) {
    gaugeSts = gaugeMatch[1]
    gaugeRows = gaugeMatch[2]
  }
  
  // Extract needle size
  // Pattern: "5 mm (8 US) (6 UK)" or "5mm (8 US)"
  const needleMatch = profileText.match(/(\d+(?:\.\d+)?)\s*mm\s*\((\d+(?:\.\d+)?)\s*US\)/i) ||
                      profileText.match(/Needles[:\s]+(\d+(?:\.\d+)?)\s*mm\s*\((\d+(?:\.\d+)?)\s*US\)/i)
  
  let needleMm: number | undefined
  let needleUs: number | undefined
  
  if (needleMatch) {
    needleMm = parseFloat(needleMatch[1])
    needleUs = parseFloat(needleMatch[2])
  }
  
  return {
    name: yarnName,
    brand: brand,
    length: length,
    weight: weight,
    material: materialMatch && materialMatch[1] ? materialMatch[1].trim() : '',
    length_unit: lengthUnit,
    weight_unit: weightUnit,
    gauge_sts: gaugeSts || undefined,
    gauge_rows: gaugeRows || undefined,
    gauge_needle_mm: needleMm,
    gauge_needle_us: needleUs
  }
}
